import { t } from '../../i18n/translations';
import {
    ACTION__MODAL__TAB__JOBS,
    ACTION__MODAL__TAB__PRODUCTION,
    ACTION__MODAL__TAB__STORAGE,
    ACTION__SETTLEMENT__HIRE_ASSISTANT,
    ACTION__SETTLEMENT__HIRE_LUMBERJACK,
} from '../../engine/input/actionIds';
import type { TutorialContext, TutorialStep } from './types';
import { getActiveModal } from './helpers';

const ASSISTANT_TARGET = 2;
const LUMBERJACK_TARGET = 10;

export function buildWorkforceSteps(ctx: TutorialContext): TutorialStep[] {
    const { state, settlement, settlementTileId, lang } = ctx;
    return [
        {
            id: 'click-city',
            title: t(lang, 'tutorial.workforce.step1.title'),
            body: t(lang, 'tutorial.workforce.step1.body'),
            target: { type: 'tile', tileId: settlementTileId },
            allowActionIds: [],
            condition: () => state.activeModalId === settlementTileId,
        },
        {
            id: 'open-jobs',
            title: t(lang, 'tutorial.workforce.step2.title'),
            body: t(lang, 'tutorial.workforce.step2.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__JOBS },
            allowActionIds: [ACTION__MODAL__TAB__JOBS],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__JOBS,
        },
        {
            id: 'hire-lumberjacks',
            title: t(lang, 'tutorial.workforce.step3.title'),
            body: t(lang, 'tutorial.workforce.step3.body', LUMBERJACK_TARGET),
            target: { type: 'action', actionId: ACTION__SETTLEMENT__HIRE_LUMBERJACK },
            allowActionIds: [ACTION__SETTLEMENT__HIRE_LUMBERJACK],
            condition: () =>
                settlement ? settlement.jobs.lumberjacks >= LUMBERJACK_TARGET : false,
        },
        {
            id: 'open-production',
            title: t(lang, 'tutorial.workforce.step4.title'),
            body: t(lang, 'tutorial.workforce.step4.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__PRODUCTION },
            allowActionIds: [ACTION__MODAL__TAB__PRODUCTION],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__PRODUCTION,
        },
        {
            id: 'back-to-jobs',
            title: t(lang, 'tutorial.workforce.step5.title'),
            body: t(lang, 'tutorial.workforce.step5.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__JOBS },
            allowActionIds: [ACTION__MODAL__TAB__JOBS],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__JOBS,
        },
        {
            id: 'assign-assistants',
            title: t(lang, 'tutorial.workforce.step6.title'),
            body: t(lang, 'tutorial.workforce.step6.body', ASSISTANT_TARGET),
            target: { type: 'action', actionId: ACTION__SETTLEMENT__HIRE_ASSISTANT },
            allowActionIds: [ACTION__SETTLEMENT__HIRE_ASSISTANT],
            condition: () => (settlement ? settlement.jobs.assistants >= ASSISTANT_TARGET : false),
        },
        {
            id: 'open-storage',
            title: t(lang, 'tutorial.workforce.step7.title'),
            body: t(lang, 'tutorial.workforce.step7.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__STORAGE },
            allowActionIds: [ACTION__MODAL__TAB__STORAGE],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__STORAGE,
        },
    ];
}
